/**
 * Locale constants for regional spelling and formatting
 * en-AU: Australian English (e.g. customisation, organisation)
 * en-US: US English (e.g. customization, organization)
 */

export type Locale = 'en-AU' | 'en-US'

export const LOCALE_PREFERENCE_KEY = 'locale'

export const DEFAULT_LOCALE: Locale = 'en-AU'

export interface ILocaleOption {
  value: Locale
  label: string
  flag: string
}

export const LOCALE_OPTIONS: ILocaleOption[] = [
  { value: 'en-AU', label: 'Australian English', flag: '🇦🇺' },
  { value: 'en-US', label: 'US English', flag: '🇺🇸' },
]
